module.exports = "/lucky-balls/img/bonus_yellow/header_surebet247.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_surebet247.png
// module id = 971
// module chunks = 0